import React from 'react';
import classnames from 'classnames';

import { FormattedDate, LocaleString } from '@biw/intl';
import { ProgramModel } from '@biw/contests-core/lib/dux/programs';

import DaysLeft from './days-left';
import ProgramLogo from './program-logo';

import './program-header.scss';

interface Props {
    program: ProgramModel;
    dataThrough: string;
}

export default class ProgramHeader extends React.Component<Props> {
    public render() {
        const {
            program,
            dataThrough,
        } = this.props;

        const calendarHidden = program.missedGoalSelection || program.isFinalResults || program.programHasEnded;
        return (
            <header role="presentation" className={classnames( 'program-header-container', { 'with-calendar': !calendarHidden } )}>
                <div className="branding-hero-image">
                    <div className="program-header">

                        { program.programLogo &&
                            <ProgramLogo program={program} />
                        }

                        <div className="program-info">
                            <h1 id="programTitle" className="program-title" data-sel="goal-selection-program-name">{program.programName}</h1>
                            <span className="program-info-wrapper">
                                { !program.programHasStarted && program.isObjectives &&
                                    <h2>
                                        <p className="program-info-obj-summary">{program.objectiveSummary || ''}</p>
                                        <p className="program-info-obj-summary">
                                            <strong><LocaleString code="objective.progress.description" /></strong>
                                        </p>
                                    </h2>
                                }
                                { !program.programHasStarted && !program.isObjectives &&
                                    <h2 className="date-label" id="goalSelectionDatesHiddenDateLabel">
                                        <LocaleString code="programInfoHeader.goalSelectionPeriod" />&nbsp;
                                        <strong data-sel="goal-selection-period">
                                            <FormattedDate value={program.goalSelectionFromDate} />&nbsp;&#45;&nbsp;<FormattedDate value={program.goalSelectionToDate} />
                                        </strong>
                                    </h2>
                                }

                                <h2 className="date-label">
                                    <LocaleString code="programInfoHeader.programDates" />&nbsp;
                                    <strong data-sel="goal-selection-program-dates">
                                        <FormattedDate value={program.startDate} />&nbsp;&#45;&nbsp;<FormattedDate value={program.endDate} />
                                    </strong>
                                </h2>

                                { dataThrough && program.hasProgress &&
                                    <h3 className="date-label" id="dataThroughDateLabel">
                                        <LocaleString code="programInfoHeader.dataThrough" />&nbsp;
                                        <strong><FormattedDate value={dataThrough} /></strong>
                                    </h3>
                                }
                            </span>
                        </div>
                        { !calendarHidden &&
                            <DaysLeft program={program} />
                        }
                    </div>
                </div>
            </header>
        );
    }
}
